import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  SSOErrorWrapper,
  SSOErrorHeader,
  SSOErrorSubheader,
  SSOErrorDescription,
  SSOStep,
  SSOStepText,
  HighlightedText,
  SSOErrorContentRow,
  SSOErrorImage,
  SSOStepRow,
  SSOContactSupport,
} from '../styles';

export const RouteOneSsoError: React.FC = () => {
  const { t } = useTranslation();

  return (
    <SSOErrorWrapper>
      <div>
        <SSOErrorHeader>{t('components.ssoErrorPage.title')}</SSOErrorHeader>
        <SSOErrorSubheader>{t('components.ssoErrorPage.subheader')}</SSOErrorSubheader>
        <SSOErrorDescription>{t('components.ssoErrorPage.description')}</SSOErrorDescription>
        <SSOErrorContentRow>
          <div>
            <SSOStepRow>
              <SSOStep>{t('components.ssoErrorPage.steps.step1')}</SSOStep>
              <SSOStepText>
                {t('components.ssoErrorPage.stepsDescription.step1')}{' '}
                <HighlightedText>{t('components.ssoErrorPage.stepsDescription.step1Highlighted')} </HighlightedText>
                {t('components.ssoErrorPage.stepsDescription.step1Postfix')}
              </SSOStepText>
            </SSOStepRow>
            <SSOStepRow>
              <SSOStep>{t('components.ssoErrorPage.steps.step2')}</SSOStep>
              <SSOStepText>
                {t('components.ssoErrorPage.stepsDescription.step2')}{' '}
                <HighlightedText>{t('components.ssoErrorPage.stepsDescription.step2Highlighted')} </HighlightedText>
                {t('components.ssoErrorPage.stepsDescription.step2Postfix')}{' '}
                <HighlightedText>
                  {t('components.ssoErrorPage.stepsDescription.step2PostfixHighlighted')}
                </HighlightedText>
              </SSOStepText>
            </SSOStepRow>
            <SSOStepRow>
              <SSOStep>{t('components.ssoErrorPage.steps.step3')}</SSOStep>
              <SSOStepText>
                {t('components.ssoErrorPage.stepsDescription.step3')}{' '}
                <HighlightedText>{t('components.ssoErrorPage.stepsDescription.step3Highlighted')}</HighlightedText>
              </SSOStepText>
            </SSOStepRow>
          </div>
          <SSOErrorImage />
        </SSOErrorContentRow>
        <SSOContactSupport>
          <div>
            {t('components.ssoErrorPage.contactSupport.text')}{' '}
            <a href={`mailto:${t('components.ssoErrorPage.contactSupport.email')}`}>
              {t('components.ssoErrorPage.contactSupport.email')}
            </a>{' '}
            {t('components.ssoErrorPage.contactSupport.textPostfix')}
          </div>
        </SSOContactSupport>
      </div>
    </SSOErrorWrapper>
  );
};
